import { useContext } from "react";
import { machineTypeSchema } from "@packsize/schemas/machines";

import { ProductionContext } from "@/contexts/production";

import { ManualMachineControlTemplate } from "./manual-machine-control.template";

export const ManualMachineControl = () => {
	const { currentMachineGroup } = useContext(ProductionContext);

	const manualControlMachineIds = Object.entries(currentMachineGroup?.configuredMachinesWithMachineType ?? {})
		.filter(([, machineType]) => machineType === machineTypeSchema.enum.Em)
		.map(([machineId]) => machineId);

	return <ManualMachineControlTemplate machineIds={manualControlMachineIds} />;
};
